export default __webpack_public_path__ + "static/media/type_14_2.4778dad6.svg";